// this controls what order it shows up in
const FUNCTIONAL_AREA_NAME_SORT_LIST = [
  'Regional Consultants',
  'Strategic Beta Specialist', // legacy label
  'Strategic Beta Consultant',
  'DCIO/Retirement Plans Specialists', // legacy label
  'Retirement Investment Consultants',
]

const SALES_CONTACT_TYPE_SORT_LIST = ['External', 'Internal']

/**
 * @param salesContactByChannelArray
 * @param type
 * @returns {Array}
 */
function getContactArrayByType(salesContactByChannelArray, type) {
  const salesContactInfo = []
  const salesContactByChannel = salesContactByChannelArray
    ? salesContactByChannelArray.slice(0)
    : [] // make a copy

  for (const salesContact of salesContactByChannel) {
    if (salesContact.isPrimaryInd === type) {
      // splice this up if its too big (test data has been returning more than 2)
      if (salesContact.salesContactInfo.length > 2) {
        salesContact.salesContactInfo = salesContact.salesContactInfo.splice(
          0,
          2
        )
      }

      salesContactInfo.push(salesContact)
    }
  }

  return salesContactInfo
}

/**
 * This is a really bad idea. I am doing sorting based on the content, that could very well change.
 * I don't have anything else to sort against, so when this content changes, or we get new content, and we wonder
 * how this magical list sorts, this is where you will find it. #dontblamebao
 *
 * The order is controlled by FUNCTIONAL_AREA_NAME_SORT_LIST, so if you have something new, or the content changed, go update that list
 *
 * @param a
 * @param b
 */
function magicalSortingByFunctionalAreaNm(a, b) {
  const aScore = lookupSortWeightScore(
    FUNCTIONAL_AREA_NAME_SORT_LIST,
    a.functionalAreaNm
  )
  const bScore = lookupSortWeightScore(
    FUNCTIONAL_AREA_NAME_SORT_LIST,
    b.functionalAreaNm
  )

  return sortScore(aScore, bScore)
}

/**
 * Sigh... we have to also sort the Internal/External users from the primary contacts
 * @param a
 * @param b
 */
function moreMagicalSortingByTheInternalExternalUserStuff(a, b) {
  const aScore = lookupSortWeightScore(
    SALES_CONTACT_TYPE_SORT_LIST,
    a.salesContactTypeCd
  )
  const bScore = lookupSortWeightScore(
    SALES_CONTACT_TYPE_SORT_LIST,
    b.salesContactTypeCd
  )

  return sortScore(aScore, bScore)
}

function sortScore(aScore, bScore) {
  if (aScore > bScore) {
    return 1
  } else if (aScore < bScore) {
    return -1
  } else {
    return 0
  }
}

/**
 * Returns the index of the array when it finds it. The score for sort is just based on the position in the array #medivhcheats
 * @param sortingArray
 * @param functionalAreaNm
 * @returns {number}
 */
function lookupSortWeightScore(sortingArray, functionalAreaNm) {
  sortingArray.map((index) => {
    if (index === functionalAreaNm) {
      return index
    }

    return 0
  })
}

export function getFullDisplayableWholeSalers(_wholeSalers) {
  const wholeSalersToDisplay = []

  if (_wholeSalers) {
    // start with primary
    const primarySalesContactInfo = getContactArrayByType(
      _wholeSalers.salesContactByChannel,
      'Y'
    )
    if (primarySalesContactInfo && primarySalesContactInfo.length > 0) {
      primarySalesContactInfo[0].salesContactInfo.sort(
        moreMagicalSortingByTheInternalExternalUserStuff
      )
      wholeSalersToDisplay.push(primarySalesContactInfo[0])
    }

    // secondary contacts
    let nonPrimarySalesContactInfo = getContactArrayByType(
      _wholeSalers.salesContactByChannel,
      'N'
    )
    nonPrimarySalesContactInfo = nonPrimarySalesContactInfo.sort(
      magicalSortingByFunctionalAreaNm
    )
    for (const nonPrimarySales of nonPrimarySalesContactInfo) {
      //i guess we sort the external and internal here too
      nonPrimarySales.salesContactInfo.sort(
        moreMagicalSortingByTheInternalExternalUserStuff
      )

      wholeSalersToDisplay.push(nonPrimarySales)
    }

    return wholeSalersToDisplay
  }
}

export {
  getContactArrayByType,
  magicalSortingByFunctionalAreaNm,
  moreMagicalSortingByTheInternalExternalUserStuff,
}
